export default defineAppConfig({
    nuxtQuasar: {
        brand: {
            primary: '#1976d2',
            secondary: '#ffc107',
            accent: '#607d8b',
            dark: '#1d1d1d',
            positive: '#21ba45',
            negative: '#c10015',
            info: '#31ccec',
            warning: '#f2c037'
        },
        loadingBar: {
            color: "secondary",
        },
    }
})
  